import { createSlice } from "@reduxjs/toolkit";

import {
  bloggersProfilesParamsForRedux,
} from "../../pages/bloggers_profiles_selection/data";

export const bloggersProfilesParams = {
  source: [],
  brand_id: [],
  account_name_hash: [],
  subject_id: [],
  product_id: [],
  success_level_avg: "",
  subscriber_count__gte: "",
  subscriber_count__lte: "",
  limited: false,
  ...bloggersProfilesParamsForRedux,
};

const initialState = {
  params: {
    ...bloggersProfilesParams,
  },
  ordering: "-w_proceeds_avg",
};

const bloggersProfiles = createSlice({
  name: "bloggersProfiles",
  initialState,
  reducers: {
    setBloggersProfilesParamByName(state, { payload: { value, name } }) {
      state.params[name] = value;
    },
    setBloggersProfilesParams(state, { payload: savedParams }) {
      state.params = {
        ...savedParams,
        limited: savedParams.limited === true || savedParams.limited === "true",
      };
    },
    resetBloggersProfilesFilters(state) {
      state.params = bloggersProfilesParams;
    },
    setBloggersProfilesOrdering(state, { payload: value }) {
      state.ordering = value;
    },
  },
});

export default bloggersProfiles.reducer;
export const {
  setBloggersProfilesParamByName,
  setBloggersProfilesParams,
  resetBloggersProfilesFilters,
  setBloggersProfilesOrdering,
} = bloggersProfiles.actions;
